import React from "react"
import ServiceCard from "./ServiceCard"
import services from "../../data/services"
import { Link } from "react-router-dom"
import { logMessage } from "../../utils/utils"

const MainServices = () => {
  const handleClick = () => {
    logMessage("Відкрити повний перелік послуг із цінами")
  }

  return (
    <div className="max-w-[1110px] mx-auto px-6 ">
      <div className="mx-auto max-w-max">
        <div className="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-12  justify-around">
          {services.map((serv) => (
            <ServiceCard key={serv.titleUa} serv={serv} />
          ))}
        </div>
      </div>
      <div className="mx-3">
        <div
          className=" mt-16 text-xl border max-w-max mx-auto py-2 px-3 rounded-lg text-white bg-[#002998ef] hover:scale-105 duration-300"
          onClick={() => window.scrollTo({ top: 0 })}
        >
          <Link to="../prices" className="py-2 px-3" onClick={handleClick}>
            Відкрити повний перелік послуг із цінами
          </Link>
        </div>
      </div>
    </div>
  )
}

export default MainServices
